export default "__VITE_ASSET__DMNu55U$__"